import { render, staticRenderFns } from "./SelfSendEntrustFlow.vue?vue&type=template&id=918873d6"
import script from "./SelfSendEntrustFlow.vue?vue&type=script&lang=js"
export * from "./SelfSendEntrustFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports